<template>
  <div class="wrap">
    <div class="search-page-wrap">
      <div class="data-table-title white">インフルエンサーリクエスト・インポート</div>
      <el-tabs v-model="activeName" class="tab-report">
        <el-tab-pane label="新規リクエスト・インポート" name="new">
          <requestTop v-if="activeName == 'new'" ref="requestTop" />
        </el-tab-pane>

        <el-tab-pane label="リクエスト履歴" name="history" v-if="view_request_enabled">
          <requestHistory v-if="activeName == 'history'" />
        </el-tab-pane>

        <el-tab-pane label="インポート履歴" name="import">
          <importHistory v-if="activeName == 'import'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import requestHistory from "./request_history.vue";
import importHistory from "./import_history.vue";
import requestTop from "./request_top.vue";

export default {
  name: "request",
  components: {
    requestHistory,
    importHistory,
    requestTop,
  },
  data() {
    return {
      activeName: "new",
      request_drawer: false,
      import_drawer: false,
      influencer_bulk: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    email() {
      return this.$store.state.email;
    },
    email_private() {
      return this.$store.state.email_private;
    },
    view_request_enabled() {
      return this.$store.state.service_plan.view_request_enabled;
    },
  },
  mounted() {
    this.scrollTop();
    this.$store.dispatch("changeActive", "request");
    this.$nextTick(()=>{
      this.loadParams();
    })
  },
  methods: {
    loadParams() {
      var sns_type = this.$route.params.sns_type;
      this.influencer_bulk = this.$route.params.influencer_bulk;
      this.request_drawer = this.$route.params.request_drawer;
      this.import_drawer = this.$route.params.import_drawer;
      if (this.request_drawer == true) {
        this.$refs.requestTop.openRequestDrawer(this.influencer_bulk, sns_type)
        this.request_drawer = false;
        // this.influencer_bulk = [];
      }
      if (this.import_drawer == true) {
        this.$refs.requestTop.openImportDrawer()
        this.import_drawer = false;
      }
    },
    scrollTop() {
      window.scroll({
        top: 0,
        behavior: "instant",
      });
    },
  },
  watch: {},
  filters: {},
};
</script>
